// extracted by mini-css-extract-plugin
export default {"Info":"Info-styles__Info__d7gYq","Info__icon--fill":"Info-styles__Info__icon--fill__M6tgT","Info__icon--stroke":"Info-styles__Info__icon--stroke__pumu8"};